// Use server eligibility to attach rewards to the paid products that earned them.
// An offer earned across several products belongs to their shared group, once.
export function groupProductOffers(items, quote) {
    let groups = items.map(item => ({items:[item], promotionIds:[]}));
    const offerIds = new Set([
        ...(quote?.reward_choices || []).map(choice => String(choice.promotion_id)),
        ...(quote?.reward_items || []).map(item => String(item.reward_promotion_id)),
    ]);
    const unassigned = [];
    offerIds.forEach(id => {
        const choice = quote?.reward_choices?.find(choice => String(choice.promotion_id) === id);
        const applied = quote?.applied_promotions?.find(promotion => String(promotion.promotion_id) === id);
        const skus = new Set((choice?.qualifying_product_sku_ids || applied?.qualifying_product_sku_ids || []).map(Number));
        [...items, ...(quote?.items || []).filter(item => !item.is_reward)].forEach(item => {
            if (item.applied_promotions?.some(promotion => String(promotion.promotion_id) === id)) skus.add(Number(item.product_sku_id));
        });
        const matches = groups.filter(group => group.items.some(item => skus.has(Number(item.product_sku_id))));
        if (!matches.length) {unassigned.push(id); return;}
        const merged = {items:matches.flatMap(group => group.items), promotionIds:[...matches.flatMap(group => group.promotionIds),id]};
        const first = groups.indexOf(matches[0]);
        groups = groups.filter(group => !matches.includes(group));
        groups.splice(first,0,merged);
    });
    return {groups, unassigned};
}

export function rewardQuoteFor(quote, promotionIds) {
    const ids = new Set(promotionIds);
    return {...quote,
        reward_choices:quote?.reward_choices?.filter(choice => ids.has(String(choice.promotion_id))),
        reward_items:quote?.reward_items?.filter(item => ids.has(String(item.reward_promotion_id))),
    };
}
